const purchaseHistoryPT = {
    "view": {
        "table": {
            "title": "Seu histórico de compras",
            "column": {
                "amount": "Quantia",
                "description": "Descrição",
                "credits_balance": "Saldo de Créditos",
                "tokens_balance": "Saldo de Tokens",
                "date_of_purchase": "Data da Compra",
                "receipt": "Recibo"
            },
            "placeholder": {
                "search": "Pesquisar..."
            },
            "button": {
                "view": "Ver",
                "export_csv": "Exportar CSV"
            }
        }
    }
};

export default purchaseHistoryPT;